import { Control } from "@react-typed-forms/core";
import {
  convertPath,
  errorMessage,
  isFluentError,
  pathBasedErrors,
} from "@astroapps/client";
import { ApiException } from "./client.ts";

/**
 * Returns a catch-handler that maps a 400 validation response onto a form control.
 * Usage:  await save().catch(applyValidationErrors(form));
 */
export function applyValidationErrors(
  control: Control<any>,
  scrollToError = true,
) {
  return (e: unknown): Control<any>[] | undefined => {
    // The generated client throws the *parsed* 400 body directly (because the
    // 400 response is typed), so `e` is usually the fluent-error object itself.
    // It only wraps in ApiException when there's no body to deserialize.
    const body =
      ApiException.isApiException(e) && e.status === 400 && e.response
        ? JSON.parse(e.response)
        : e;
    if (body && isFluentError(body)) {
      control.clearErrors();
      const errors = body.errors.map(({ path, error }) => ({
        path: convertPath(path),
        error,
      }));
      return pathBasedErrors(
        control,
        errors,
        (c, err) => c.setError("default", errorMessage(err)),
        scrollToError,
      );
    }
    throw e; // not a validation error — rethrow
  };
}
